"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("../../openapi");
const ValidationErrorCode_1 = __importDefault(require("./ValidationErrorCode"));
class ValidationIssue {
    path = '';
    modelType = '';
    errorCode;
    fieldName;
    value;
    issueType;
    constructor(modelType, errorCode, fieldName, value, path, issueType) {
        this.modelType = modelType;
        this.errorCode = errorCode;
        this.fieldName = fieldName;
        this.value = value;
        if (path) {
            this.path = path;
        }
        if (issueType) {
            this.issueType = issueType;
        }
    }
}
__decorate([
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'The JSON path of the incorrect parameter',
    })
], ValidationIssue.prototype, "path", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', description: 'The Model of the schema' })
], ValidationIssue.prototype, "modelType", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'number',
        enum: Object.values(ValidationErrorCode_1.default),
        description: 'The number of the ValidationErrorCode',
    })
], ValidationIssue.prototype, "errorCode", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'The name of the field that triggered the error throw',
    })
], ValidationIssue.prototype, "fieldName", void 0);
__decorate([
    (0, openapi_1.Schema)({
        description: 'The value of the field that triggered the error throw',
    })
], ValidationIssue.prototype, "value", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        description: 'The issueType returned by Joi',
    })
], ValidationIssue.prototype, "issueType", void 0);
exports.default = ValidationIssue;
